import React from 'react';
import { Dropdown, DropdownTrigger, DropdownMenu, DropdownItem, Button } from '@heroui/react';
import { useNavigate } from 'react-router-dom';
import { Share2, ChevronDown, LogOut } from 'lucide-react';
import { useLogout } from '@/entities/auth';
import { useAuthStore } from '@/shared/lib/store';
import { logger } from '@/shared/lib';

export const CompanyDropdown: React.FC = () => {
  const navigate = useNavigate();
  const logoutMutation = useLogout();
  const { tokens, clearAuth } = useAuthStore();

  const handleLogout = async () => {
    try {
      if (tokens?.refresh_token) {
        await logoutMutation.mutateAsync({
          body: { refresh_token: tokens.refresh_token },
        });
      }
    } catch (error) {
      logger.error('Logout failed:', error);
    } finally {
      clearAuth();
      navigate('/login');
    }
  };
  return (
    <Dropdown placement="bottom-start">
      <DropdownTrigger>
        <Button
          variant="light"
          className="w-full justify-start p-0 h-auto data-[hover=true]:bg-transparent"
        >
          <div className="flex items-center gap-4 w-full">
            <div className="flex-shrink-0 w-10 h-10 bg-primary rounded-lg flex items-center justify-center">
              <Share2 className="text-white w-5 h-5" />
            </div>
            <div className="flex-1 text-left">
              <p className="text-sm font-semibold text-foreground">소셜관리시스템</p>
              <p className="text-xs text-default-500">관리자</p>
            </div>
            <ChevronDown className="w-3 h-3 text-default-400" />
          </div>
        </Button>
      </DropdownTrigger>
      <DropdownMenu 
        aria-label="Company actions"
        variant="flat"
        classNames={{
          base: "w-64 max-w-64 bg-background dark:border-default-100",
          list: "py-1 px-1",
        }}
      >
        <DropdownItem 
          key="logout" 
          color="danger"
          onPress={handleLogout}
          startContent={
            <div className="flex h-8 w-8 items-center justify-center rounded-full bg-danger/10">
              <LogOut className="w-4 h-4 text-danger" />
            </div>
          }
          classNames={{
            base: "py-3 px-3 gap-3 rounded-lg data-[hover=true]:bg-danger/10 data-[selectable=true]:focus:bg-danger/10",
            wrapper: "w-full",
            title: "text-sm font-medium text-danger"
          }}
        >
          로그아웃
        </DropdownItem>
      </DropdownMenu>
    </Dropdown>
  );
};